import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "917518388162";
const WHATSAPP_MESSAGE = "Hi, I need support.";

export function WhatsAppSupportButton() {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-4 sm:bottom-6 sm:right-6 z-40 hidden items-center justify-center rounded-full bg-green-500 text-white shadow-lg shadow-green-500/30 transition-all duration-200 hover:bg-green-600 hover:shadow-xl hover:shadow-green-500/40 active:scale-95 lg:inline-flex lg:h-auto lg:w-auto lg:gap-2 lg:px-4 lg:py-3"
      aria-label="Contact WhatsApp support"
      title="WhatsApp Support"
    >
      <FaWhatsapp className="h-6 w-6" />
      <span className="text-sm font-semibold whitespace-nowrap">Need help? Chat with us</span>
    </a>
  );
}
